import React from 'react';
import i18n from 'i18n-js';

import Right from "./Right";
import Panel from "./Panel";
import FormItem from "./FormItem";
import CoolLoader2 from "./CoolLoader2";
import langs from "./langs/phpIndex";
import appLangs from "./langs/appIndex";

import {api, beutifyDepartments} from "./baseFunctions";
import {Link} from "react-router";
import {history} from "../store";

class SubPage extends React.Component {
	constructor(){
		super();
		this.getData = this.getData.bind(this);
		this.updateEdit = this.updateEdit.bind(this);
		this.save = this.save.bind(this);
		this.types = ["REPORT"];//, "NO_RAS"]; //"NEW_REPORT", "NEW_OBS", "NEW_OBS_TYPE", 
		this.state = {
			data: false,
			currType: false,
			currObsType: 0,
			sheet: false,
			depStruct: false,
			deparments: [],
			groups: [],
			currSheet: false,
		};
	}
	componentDidMount(){
		this.getData();
		this.updateEdit();
	}
	save(e)
	{
		const IS_EDIT = this.props.params.id && this.props.params.id !== "new" && this.state.data[Number(this.props.params.id)] ? this.state.data[Number(this.props.params.id)] : false;
		e.preventDefault();
		const FORM = {};
		Object.keys(this.refs).map((d) => FORM[d] = this.refs[d].value);
		if(IS_EDIT)
		{
			FORM.id = IS_EDIT.id;
		}
		if(FORM.type !== "REPORT")
		{
			FORM.sheetID = this.state.currSheet.id;
			if(this.refs.obsType)
			{
				FORM.compID = Number(this.refs.obsType.dataset.id);
				FORM.valID = Number(this.refs.obsVal.value);
			}
		}

		api("POST", {"type": "saveSub", data: FORM}, (d) => {
      if(!d.error)
      {
      	//console.log(d, this);
      	history.push("/sub");
      	requestAnimationFrame(() => this.getData());
      }
    }, this.props.auth, 1);
	}
	getData(){
		this.setState({
			data: false
		});
		api("POST", {"type": "getSubs"}, (d) => {
			if(!d.error)
			{
				this.setState({
					data: d.data
				});
			}
		}, this.props.auth, 1);
		api("POST", {"type": "sync"}, (d) => {
			if(!d.error)
			{
				this.setState({
					groups: d.data.groups,
				});
			}
		}, this.props.auth, 1);

		api("POST", {"type": "obsSheet"}, (d) => {
			if(!d.error)
			{
				this.setState({
					sheet: d.data
				});
						this.updateEdit();
			}
		}, this.props.auth, 1);

		api("POST", {"type": "getDepartments"}, (d) => {
			if(!d.error)
			{
				this.setState({
					deparments: d.data.ids,
					depStruct: d.data.data,
				});
			}
		}, this.props.auth, 1);
	}

	updateEdit()
	{
		const IS_EDIT = this.props.params.id && this.props.params.id !== "new" && this.state.data[Number(this.props.params.id)] ? this.state.data[Number(this.props.params.id)] : false;
		
		if(IS_EDIT)
		{
			let type = this.types.find((d) => d === IS_EDIT.type);
			this.setState({
				currType: type
			});
		}
	}


	beutifyDepartments(root, selected)
	{
		// console.log("Beutify deps", root);
		let deps = [];
		const depthFunc = (dep, depth = 0) => {
			deps.push({
				...dep,
				level: depth
			});
			dep.children.forEach(child => depthFunc(child, depth + 1));
		};
		if(root)
		{
			depthFunc(root);
		}

		//console.log("Beutify", arr, this.state.deparments);
			return deps.map((d, key) => {
				let extras = "";
				if(d.level > 0)
				{
					for(let i = 0; i < d.level; i++)
					{
						extras += "--";
					}
					extras += ">";
				}
				let check = typeof selected === "object" ? (selected.indexOf(d.id) !== -1) : (selected === d.id);
				// console.log(selected, "===", d.id);
				if(check)
				{
					// console.log("Check me", d);
				}
				return (<option key={"dep" + key} value={d.id} selected={check}>{extras} #{d.id} {d.name}</option>);
			});
	}

	/**
	 * Kun lavet til RADIO og SELECT
	 * @param {*} questions 
	 * @param {*} types 
	 */
	filterComponents(questions, types, isFirst = true, siblings = questions, parent = null)
	{
		return questions.map(question => {
			let tempFirst = isFirst;
			if(types.includes(question.type))
			{
				tempFirst = false;
				if(!isFirst)
				{
					question.parent = parent;
					question.siblings = siblings;
					return question; 
				}
			}
			return this.filterComponents(question.children, types, tempFirst, tempFirst ? question.children : siblings, tempFirst ? question : parent).flat();
		}).flat();
	}

	render(){
		const LANG = langs[this.props.lang];
		const APP_LANG = appLangs[this.props.lang];
		const IS_NEW = this.props.params.id && this.props.params.id === "new";
		//const TYPES = ["NEW_REPORT", "NEW_OBS", "NEW_OBS_TYPE"];//, "NO_RAS"];
		const SEND_TYPES = LANG['NOT_SEND_TYPES'];
		const TYPE_LANG = LANG['NOT_TYPES'];
		const IS_EDIT = this.props.params.id && this.props.params.id !== "new" && this.state.data[Number(this.props.params.id)] ? this.state.data[Number(this.props.params.id)] : false;
		const GROUPS = (this.state.groups.length === 0 ? this.props.groups : this.state.groups);

		const SHEET = this.state.currSheet;//this.state.sheet ? this.state.sheet[0] : false;
		let defaultObsType = false;
		// if(IS_EDIT && SHEET)
		// {
		// 	defaultObsType = SHEET.components.map((d, key) => ({...d, key})).find((d) => d.id === IS_EDIT.compID);
		// }

		const sheetQuestions = this.filterComponents(SHEET ? SHEET.questions : [], ["radio"]);
		console.log("Curr type", this.state.currType, this.state.currSheet);
		console.log("Test", sheetQuestions);

		return (<Right title={LANG['NOT_TITLE']} token={this.props.auth} lang={this.props.lang}>
							{
                this.props.params.id ? 
                	<Panel title={IS_NEW ? LANG['NEW_NOT'] : LANG['EDIT_NOT']} key={IS_EDIT ? this.props.params.id : IS_EDIT.id}>
                		<form onSubmit={this.save}>
	                		<FormItem name={LANG['TYPE']} must={true}>
	                			<select className="form-control col-md-7 col-xs-12" ref="type" required={true} defaultValue={IS_EDIT ? IS_EDIT['type'] : false} onChange={(e) => {
									const target = e.target;
									const option = target.selectedOptions[0];

									this.setState({
										currType: target.value,
										currSheet: GROUPS[Number(option.dataset.i)] ? GROUPS[Number(option.dataset.i)].sheets[Number(option.dataset.sheeti)] : false,
									});	
								}}>
								<option value={"0"}></option>
									{
										GROUPS.map((group, i) => [
											{
												name: i18n.t(group.name),
												isTitle: true,
												i: 0,
												sheetI: 0,
											},
											...group.sheets.map((sheet, sheetI) => ({
												name: sheet.name,
												id: sheet.id,
												i,
												sheetI,
											}))
										]).flat().map(d => <option disabled={d.isTitle} data-i={d.i} data-sheeti={d.sheetI} style={d.isTitle ? {fontWeight: "bolder", textDecoration: "underline"} : {}} value={d.id}>{!d.isTitle && "- "}{d.name}</option>)
									}
									<option disabled={1} style={{fontWeight: "bolder", textDecoration: "underline"}}>Andre</option>
									{
	                					this.types.map((d, key) => <option key={"type" + key} value={d}>{TYPE_LANG[d]}</option>)
	                				}
	                			</select>
	                		</FormItem>
	                		{
	                			this.state.currType !== "REPORT" && sheetQuestions.length > 0 ?
	                			<div>
	                				<FormItem name={LANG['QUESTION']} must={true}>
			                			<select ref="obsType" data-id={typeof this.state.currObsType === "number" ? sheetQuestions[this.state.currObsType].questionID : 0} className="form-control col-md-7 col-xs-12" defaultValue={defaultObsType ? defaultObsType.key : false} onChange={(val) => this.setState({currObsType: Number(val.target.value)})}>
											{
			                					sheetQuestions.map((question, i) => {
													return question.parent.type === "points" ? (<option value={i} key={i}>{question.siblings[0].question} [{question.question}]</option>) : (<option value={i} key={i}>{question.question}</option>);
												})
			                				}
											{/* {
			                					false ?
			                						SHEET.components.map((d,key) => ['select', 'checkbox'].indexOf(d.type) !== -1 ? <option key={"langCode" + key} value={key}>{APP_LANG[d.langCode]}</option> : null)
			                					: null
			                				} */}
			                			</select>
			                		</FormItem>
	                				{
	                					typeof this.state.currObsType === "number" ?
	                						<FormItem name={LANG['EQUALS']} must={true}>
					                			<select className="form-control col-md-7 col-xs-12" ref="obsVal" defaultValue={IS_EDIT ? IS_EDIT.compVal : false}>
												{
													sheetQuestions[this.state.currObsType].children.map((question, i) => <option value={question.questionID} key={i}>{question.question}</option>)
												}
					                				{/* {
					                					false && SHEET.components[this.state.currObsType].values.map((d,key) => <option value={d.id} key={"typeVal" + key}>{d.value}</option>)
					                				} */}
					                			</select>
					                		</FormItem>
	                					: null
	                				}
	                			</div>
	                			: null
	                		}

	                		{
	                			this.state.currType === "REPORT" ?
	                			<FormItem name={LANG['INTERVAL']} must={true}>
	                				<select className="form-control col-md-7 col-xs-12" ref="interval">
	                					<option value="d">Dagligt</option>
	                					<option value="w">Ugentlig</option>
	                					<option value="m">Månedlig</option>
	                				</select>
	                			</FormItem>
	                			: null
	                		}
	                		{
	                			this.state.currType === "NO_RAS" ?
	                			<div>
			                		<FormItem name={LANG['TIME_SINCE_RA']} must={true}>
			                			<input className="form-control col-md-7 col-xs-12" ref="to" type="number" min="0" required={true} placeholder={LANG['2_DAYS']}/>
			                		</FormItem>
			                		<FormItem name={LANG['NOTE']}>
			                			<input className="form-control col-md-7 col-xs-12" placeholder={LANG['NOTE_PLACE']} ref="note" defaultValue={IS_EDIT ? IS_EDIT['note'] : null}/>
			                		</FormItem>
			                		<select className="form-control col-md-7 col-xs-12" style={{"display": "none"}} ref="sendType" required={true} defaultValue={IS_EDIT ? IS_EDIT['sendType'] : false}>
			                				{
			                					SEND_TYPES.map((d, key) => <option key={"type" + key} value={d}>{d}</option>)
			                				}
			                			</select>
	                			</div>
	                			: 
	                			<div>
		                			<FormItem name={LANG['SEND']} must={true}>
			                			<select className="form-control col-md-7 col-xs-12" ref="sendType" required={true} defaultValue={IS_EDIT ? IS_EDIT['type'] : false}>
			                				{
			                					SEND_TYPES.map((d, key) => <option key={"type" + key} value={d}>{d}</option>)
			                				}
			                			</select>
			                		</FormItem>
			                		<FormItem name={LANG['TO']} must={true}>
			                			<input className="form-control col-md-7 col-xs-12" ref="to" required={true} defaultValue={IS_EDIT ? IS_EDIT['to'] : null}/>
			                		</FormItem>
			                		<FormItem name={LANG['DEPARTMENT']} must={true}>
			                			{/* <select className="form-control col-md-7 col-xs-12" ref="department" required={true} defaultValue={IS_EDIT ? IS_EDIT.department : IS_EDIT}>
			                				{
			                					beutifyDepartments(this.state.deparments).map((d, key) => <option key={d.key} value={d.value}>{d.text}</option>)
			                				}
			                			</select> */}
										<select className="form-control col-md-7 col-xs-12" ref="department" name="departmentList" required>
											{
												this.beutifyDepartments(this.state.depStruct, []).map((d, key) => {
													return d;
												})
											}
										</select>
			                		</FormItem>
			                		<FormItem name={LANG['NOTE']}>
			                			<input className="form-control col-md-7 col-xs-12" placeholder={LANG['NOTE_PLACE']} ref="note" defaultValue={IS_EDIT ? IS_EDIT['note'] : null}/>
			                		</FormItem>
	                			</div>
	                		}
	                		
	                		<FormItem>
	                			<button id="send" type="submit" className="btn btn-success">{LANG['SAVE']}</button>
	                		</FormItem>
                		</form>
                	</Panel>
                : null
              }
							<Panel title={LANG.VIEW} add="/sub/new" onAdd={() => console.log("Add")}>
							{
								this.state.data ?
									<table className="table table-striped jambo_table bulk_action" id="ras">
	            		<thead>
	                  <tr className="headings">
	                      <th className="column-title">{LANG['ID']}</th>
	                      <th className="column-title">{LANG['TYPE']} </th>
	                      <th className="column-title">{LANG['SEND']} </th>
	                      <th className="column-title">{LANG['TO']} </th>
	                      <th className="column-title">{LANG['NOTE']} </th>
	                      <th className="column-title"> </th>
	                  </tr>
	              	</thead>
	                <tbody>
	                	{
	                		this.state.data.map((d, key) => {
	                			return (<tr key={"table_row" + key} className={key%2 ? "odd pointer" : "even pointer"}>
						                        <td className=" ">{d.id}</td>
						                        <td className=" ">{TYPE_LANG[d.target]}</td>
						                        <td className=" ">{d.type}</td>
						                        <td className=" ">{d.to}</td>
						                        <td className=" ">{d.note}</td>
						                        <td className=" ">
						                        	{/* <Link to={"/sub/" + key}>{LANG['EDIT']}</Link> /  */}
													<Link to={"/sub"} onClick={() => {
						                        		const CONFIRM = window.confirm(LANG['REMOVE_MSG']);
						                        		if(CONFIRM)
						                        		{
						                        			api("POST", {"type": "removeSub", id: d.id}, (d) => {
																if(!d.error)
																{
																	requestAnimationFrame(() => this.getData());
																}
															}, this.props.auth, 1);
						                        		}
						                        	}}>{LANG['REMOVE']}</Link> {/* / <Link to={"/sub"}>{LANG['TEST']}</Link>*/}
						                        </td>
						                        
						                    </tr>);
	                		})
	                	}
	                </tbody>
	                </table>
                	: <CoolLoader2 show={1} type="table"/>
							}
							</Panel>
						</Right>);
	}
}

export default SubPage;


// WEBPACK FOOTER //
// ./src/components/SubPage.js